import { FunctionComponent } from 'react';
import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './SeaIce.scss';

export interface IceTypeLegendProps {
  layout: 's' | 'm';
}

const VALUES = [
  { key: 'newIce', color: '#ffafff' },
  { key: 'thinEvenIce', color: '#ff64ff' },
  { key: 'solidIce', color: '#969696' },
  { key: 'rottenSolidIce', color: '#6474a0' },
  { key: 'mostlyOpenWater', color: '#97c8ff' },
  { key: 'veryScatteredDriftIce', color: '#8cfda0' },
  { key: 'scatteredDriftIce', color: '#fffe00' },
  { key: 'compactDriftIce', color: '#ff7d07' },
  { key: 'veryCompactDriftIce', color: '#ff1f01' },
  { key: 'frozenDriftIce', color: '#910d00' },
];

export const IceTypeLegend: FunctionComponent<IceTypeLegendProps> = ({
  layout,
}) => {
  const { t } = useTranslation();

  return (
    <div className={clsx(styles.seaIceLegend, styles[layout])} aria-hidden>
      {VALUES.map((x) => (
        <div className={styles.legendValue} key={x.key}>
          <span
            className={styles.colorbar}
            style={{ background: x.color }}
          ></span>
          {t(x.key)}
        </div>
      ))}
    </div>
  );
};
